/** @format */

export const FLAG_IMPORT_CSV_FEATURE = "importCsvFeature";
export const FLAG_CHANGELOG = "changelog";
export const FLAG_SUBJECT_EXPERT_APPROVAL_QUEUE = "subjectExpertApprovalQueue";
